import {
  Card,
  CardContent,
  ResponsiveDialog,
  ResponsiveDialogContent,
  cn,
  previewPanelSurfaceClass,
} from '@up2stay/up2promo-ui';

import type { TemplateDetailPreviewProfileData } from '@/core/components/profile-templates/template-detail-preview-data';
import { IPhonePreview } from '@/core/components/ui/iphone-preview';
import { triggerTapHaptic } from '@/core/lib/dnd-haptics';
import { resolveAppAssetFileUrl } from '@/core/lib/file-url';

type TemplateDetailPreviewPaneProps = {
  workspaceId: string;
  workspaceUsername: string | null;
  previewSampleUsername: string;
  profileData: TemplateDetailPreviewProfileData;
};

export function TemplateDetailPreviewColumn({
  workspaceId,
  workspaceUsername,
  previewSampleUsername,
  profileData,
}: TemplateDetailPreviewPaneProps) {
  return (
    <Card
      className={cn('flex w-full min-w-0 flex-col', previewPanelSurfaceClass)}
    >
      <CardContent className="flex min-w-0 items-center justify-center overflow-hidden p-5 sm:p-6">
        <IPhonePreview
          username={previewSampleUsername}
          workspaceId={workspaceId}
          workspaceUsername={workspaceUsername}
          profileData={profileData}
          getFileUrl={resolveAppAssetFileUrl}
          className="w-full"
        />
      </CardContent>
    </Card>
  );
}

type TemplateDetailPreviewDialogProps = TemplateDetailPreviewPaneProps & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function TemplateDetailPreviewDialog({
  open,
  onOpenChange,
  workspaceId,
  workspaceUsername,
  previewSampleUsername,
  profileData,
}: TemplateDetailPreviewDialogProps) {
  return (
    <ResponsiveDialog
      open={open}
      onOpenChange={(next) => {
        void triggerTapHaptic();
        onOpenChange(next);
      }}
    >
      <ResponsiveDialogContent
        scrollable={false}
        className="flex max-w-4xl flex-col overflow-hidden border-b-0 p-0 md:max-h-[92vh] md:border-b"
      >
        <div className="flex min-h-0 flex-1 items-center justify-center overflow-hidden px-0 py-2 md:px-4 md:py-16">
          <IPhonePreview
            username={previewSampleUsername}
            workspaceId={workspaceId}
            workspaceUsername={workspaceUsername}
            profileData={profileData}
            getFileUrl={resolveAppAssetFileUrl}
            className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-[380px]"
          />
        </div>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
}
